import DocumentArchive from "@/pages/Documents/DocumentArchive.vue";

import { createBreadCrumbs, setNavigator } from "@/router/routerFunction";

export function routesDocuments() {
  return [
    {
      path: "/archivio-documenti",
      name: "DocumentArchiveit",
      component: DocumentArchive,
      meta: {
        breadcrumbs: [],
        indexRoute: "archivio-documenti",
        permissions: ["document_archive"],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    },
    {
      path: "/document-archive",
      name: "DocumentArchiveen",
      component: DocumentArchive,
      meta: {
        breadcrumbs: [],
        indexRoute: "document-archive",
        permissions: ["document_archive"],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    },
  ];
}
